<template>
  <section>
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="false"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LoadingIndicator',
  computed: {
    ...mapGetters('loading', [
      'isLoading',
      'isFullPage'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LoadingIndicator.vue